export const AI_CONVERSATIONS_ENDPOINT = 'api/ai-agents/conversations/'

export const AI_BILLING_BALANCE_ENDPOINT = 'api/ai-agents/billing/balance/'

export const AI_BRAIN_ORIGIN_PATH = 'model'

// Dev only: localhost can't reach `<backend>/model` (cross-origin, no CORS there).
export const AI_BRAIN_DEV_ORIGIN = 'https://openai-model.idwell.dev'

// Fake-200 the brain sends when it can't answer (balance / model down).
export const AI_LLM_UNAVAILABLE_REPLY_MARKERS = [
  'balance is exhausted',
  'top up your balance',
]

export const AI_BRAIN_LEGACY_STOPPED_REPLY = 'Generation was stopped.'

export const AI_BRAIN_TOKEN_EXPIRED_DETAIL = 'token_expired'

export const AIConversationGenerationStatus = {
  Failed: 'failed',
  Idle: 'idle',
  Running: 'running',
}

export const AIConversationMessageEventCode = {
  Failed: 'generation_failed',
  Stopped: 'generation_stopped',
}

export const AIConversationStopOutcome = {
  Completed: 'completed',
  Stopped: 'stopped',
  StopRequested: 'stop_requested',
}
